// @flow
import axios from "axios";

interface WithId {
  id: any;
}

export interface BaseRequestsInterface {
  with: any;
  fetchAll: any;
  fetch: any;
  fetchTransaction: any;
  fetchWith: any;
  create: any;
  edit: any;
  editWith: any;
  delete: any;
}

export function BaseRequests(
  endpoint: () => string,
  field: string,
  factory: () => any
) {
  const endpointSafe = function() {
    const ep = endpoint();

    return ep;
  };

  return {
    with: (pathMap: Object) => ({
      ...BaseRequests(
        () => {
          let stubEndpoint = endpoint();
          Object.keys(pathMap).forEach((key) => {
            // @ts-ignore
            stubEndpoint = stubEndpoint.replace(`:${key}`, pathMap[key]);
          });
          return stubEndpoint;
        },
        field,
        factory
      ),
    }),
    fetchAll: (filters?: string, slash?: boolean): Promise<WithId[]> => {
      let tmpAndPoint = endpointSafe();
      if (filters && slash) {
        tmpAndPoint = `${tmpAndPoint}/${filters}`;
      } else if (filters) tmpAndPoint = `${tmpAndPoint}?${filters}`;
      return Promise.resolve().then(() =>
        axios.get(tmpAndPoint).then((response: any): any => {
          if (Array.isArray(response.data.data)) {
            return {
              data: response.data.data.map((item: any) =>
                factory().deserialize(item)
              ),
              total: response.data.total,
            };
          } else {
            return factory().deserialize(response.data.data);
          }
        })
      );
    },
    fetch: (id: number | string): Promise<WithId> =>
      Promise.resolve()
        .then(() => axios.get(`${endpointSafe()}/${id}`))
        .then((response: any): any => {
          return factory().deserialize(response.data);
        }),
    fetchTransaction: (id: number | string): Promise<WithId> =>
      Promise.resolve()
        .then(() => axios.get(`${endpointSafe()}/${id}`))
        .then((response: any): any => {
          return factory().deserialize(response.data);
        }),
    fetchWith: (): Promise<WithId> =>
      Promise.resolve()
        .then(() => axios.get(`${endpointSafe()}`))
        .then((response: any): any => {
          return factory().deserialize(response.data);
        }),
    /*
     * NOT USED
     */
    // create: (data: WithId, rel?: Relationship[]): any => {
    //   if (data) {
    //     const model = new JsonApiDataStoreModel(field);
    //     Object.entries(data).forEach(([key, value]) => {
    //       model.setAttribute(key, value);
    //     });
    //     if (rel && rel.length > 0)
    //     // relationship name?
    //       rel.forEach((relation: any) => {
    //         model.setRelationship(relation.relName, relation.models);
    //       });
    //     const serializedData = model.serialize();
    //     return axios.post(endpointSafe(), serializedData);
    //   }
    //   return axios.post(endpointSafe());
    // },
    edit: (data: WithId): Promise<void> =>
      Promise.resolve()
        .then(() => axios.put(`${endpointSafe()}/${data.id}`, { data }))
        .then(() => {}),
    editWith: (data: WithId): Promise<void> =>
      Promise.resolve()
        .then(() => axios.put(`${endpointSafe()}`, { data }))
        .then(() => {}),
    delete: (id: number | string): Promise<void> =>
      Promise.resolve()
        .then(() => axios.delete(`${endpointSafe()}/${id}`))
        .then(() => {}),
  };
}
